// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2ihZl","content":"LayoutSettings_content__3322d"};